module.exports = __webpack_public_path__ + "img/empty-profile-picture.f3d4a8fe.png";